import { ProfitSummary } from '../../../../../components/ProfitSummary';
import { CurrencyRecord, SupportedCurrency } from '../../../../../domain/currency';
import { isProfitStatsDaily, isProfitStatsMonthly, StatsEntity } from '../../../../../domain/stats';
import { buildOrderMonthYearRange, StatsFilters } from '../../../../../domain/statsFilters';
import { useFindAllUsersRepository } from '../../../../../repository/users/useFindAllUsersRepository';
import { CurrencySelector } from './CurrencySelector';
import { MultipleMonthCumulativeProfitStats } from './MultipleMonthsCumulativeProfitStats';
import { SingleMonthCumulativeProfitStats } from './SingleMonthCumulativeProfitStats';

type CumulativeProfitStatsProps = {
    stats: StatsEntity;
    filters: StatsFilters;
    currencyRecord: CurrencyRecord;
    selectedCurrency: SupportedCurrency;
    onCurrencyChange: (currency: SupportedCurrency) => void;
}

export const CumulativeProfitStats = ({
    stats,
    filters,
    currencyRecord,
    selectedCurrency,
    onCurrencyChange,
}: CumulativeProfitStatsProps) => {
    const { creator } = filters;
    const { data: users = [] } = useFindAllUsersRepository();

    const selectedUser = creator ? users.find(user => user.sub === creator.id) : undefined;

    const monthYearRange = buildOrderMonthYearRange(filters);

    if (!monthYearRange) {
        return null;
    }

    const { profitStats } = stats;

    const profits: { [currency in SupportedCurrency]: number; } = {
        EUR: stats.profitStats.EUR?.total || 0,
        PLN: stats.profitStats.PLN?.total || 0,
    }

    return <>
        <div className="d-flex justify-content-between mb-3">
            <h5>
                Marża {selectedUser ?
                <b>{selectedUser.firstName} {selectedUser.lastname}</b> : 'firmy'}
                : <ProfitSummary profits={profits} currencyRecord={currencyRecord} />
            </h5>
            <CurrencySelector selectedCurrency={selectedCurrency} setSelectedCurrency={onCurrencyChange} />
        </div>
        {isProfitStatsDaily(profitStats) &&
            <SingleMonthCumulativeProfitStats
                month={monthYearRange.toMonth}
                year={monthYearRange.toYear}
                selectedCurrency={selectedCurrency}
                singleMonthStats={profitStats}
            />}
        {isProfitStatsMonthly(profitStats) &&
            <MultipleMonthCumulativeProfitStats
                multipleMonthStats={profitStats}
                selectedCurrency={selectedCurrency}
            />}
    </>;
};

